import { getDefaultConfig } from 'src/components/WidgetMaker/utils/common';

// Default data for layout and cards
export const DEFAULT_LIST_ARRANGEMENT_PRESENTATION = {
  layoutName: 'layout1',
  viewLabel: 'Collections',
  layoutType: 'grid',
  heading: '<h2>Browse the range</h2>',
  headingCharCount: 0,
  description: '',
  descriptionCharCount: 0,
  textAlign: 'left',
  colors: {
    selectedColorSchemeIndex: 0,
    colorSchemes: [
      {
        background: '#ffffff',
        text: '#000000',
        isDefault: true,
      },
      {
        background: '#000000',
        text: '#ffffff',
        isDefault: false,
      },
    ],
  },
  openInNewTab: false,
  /* This contains the configs for items that will be rendered in this widget
   * These are inserted from builder UI, where items are chosen selectively */
  contentItems: {
    isAllSelected: false, // were all items selected from builder
    type: 'collection', // type of item list
    listItem: [], // list of items
  },
  numColumnsDesktop: 4,
  numColumnsMobile: 2,
  progressIndicator: 'none',
  arrowShape: 'circular',
  arrowColor: '#000000',
  shapeColor: '#ffffff',
  arrowPosition: 'top',
  progressIndicatorColor: '#000000',
  showArrowInMobile: true,
  mobilePaddingY: 40,
  paddingY: 70,
  marginTop: 0,
  marginBottom: 0,
  /* This is the button that is shown at the bottom of the widget, to redirect to the page where all the items will be shown
   *  like our shop page or collections page or any custom page */
  viewAllItemsButtonConfig: [
    getDefaultConfig('bannerButton', '#111C36', '#FFFFFF', 'See all collections'),
  ],
};

export const DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT = {
  layoutName: 'layout1',
  viewLabel: 'Categories',
  layoutType: 'grid',
  heading: '<h2>Browse the range</h2>',
  headingCharCount: 0,
  description: '',
  descriptionCharCount: 0,
  textAlign: 'left',
  /* This signifies the color schemes that we follow, for the particular widget, user can create multiple combinations, & user
   *  can later select any one from the list */
  colors: {
    selectedColorSchemeIndex: 0,
    colorSchemes: [
      {
        background: '#ffffff',
        text: '#000000',
        isDefault: true,
      },
      {
        background: '#000000',
        text: '#ffffff',
        isDefault: false,
      },
    ],
  },
  // Signifies whether to open the item in a new tab, or redirect in the same tab
  openInNewTab: false,
  contentItems: {
    isAllSelected: false,
    type: 'category',
    listItem: [],
  },
  numColumnsDesktop: 4,
  numColumnsMobile: 2,
  progressIndicator: 'none',
  arrowShape: 'circular',
  arrowColor: '#000000',
  shapeColor: '#ffffff',
  arrowPosition: 'top',
  progressIndicatorColor: '#000000',
  showArrowInMobile: true,
  mobilePaddingY: 40,
  paddingY: 70,
  marginTop: 0,
  marginBottom: 0,
  viewAllItemsButtonConfig: [
    getDefaultConfig('bannerButton', '#111C36', '#FFFFFF', 'See all categories'),
  ],
};

export const DEFAULT_CARD_FRAME_CONFIG = {
  cardShape: 'portraitShort',
  aspectRatio: '3:4',
  hoverEffect: 'zoomIn',
  contentConfig: {
    textConfig: {
      type: 'below',
      xAlignment: 'center',
      yAlignment: 'below',
      textThicness: 'regular',
      textSize: 'medium',
      textCase: 'none',
      overlayOpacity: 1,
      /* As this is inside text config, this is the config of how the item name should look like, the available configs are same
       *  as that of button & item name can be configured similar to a button */
      appearanceButton: [getDefaultConfig('collectionBtn', '#111C36', '#111C36')],
    },
    buttonConfig: [
      {
        ...getDefaultConfig('bannerButton', '#FFFFFF', '#111C36', 'View products'),
        isShow: false,
      },
    ],
  },
};

export const DEFAULT_CARD_FRAME_CONFIG_CAT = {
  cardShape: 'portraitShort',
  aspectRatio: '3:4',
  hoverEffect: 'zoomIn',
  contentConfig: {
    textConfig: {
      type: 'below',
      xAlignment: 'center',
      yAlignment: 'below',
      textThicness: 'regular',
      textSize: 'medium',
      textCase: 'none',
      overlayOpacity: 1,
      appearanceButton: [getDefaultConfig('collectionBtn', '#111C36', '#111C36')],
    },
    buttonConfig: [
      {
        ...getDefaultConfig('bannerButton', '#FFFFFF', '#111C36', 'View products'),
        isShow: false,
      },
    ],
  },
};

export const LIST_LAYOUT_SELECTABLES = [
  {
    name: 'layout1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/eVb88qUO.webp',
    // These are the base configs meapped with each layout
    configs: {
      layout: {
        layoutName: 'layout1',
        layoutType: 'grid',
      },
      card: {
        contentConfig: {
          buttonConfig: [{ isShow: false }],
        },
      },
    },
  },
  {
    name: 'layout2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/VIpuX8Me.webp',
    // These are the base configs mapped with each layout
    configs: {
      layout: {
        layoutName: 'layout2',
        layoutType: 'carousel',
      },
      card: {
        contentConfig: {
          buttonConfig: [{ isShow: false }],
        },
      },
    },
  },
  {
    name: 'layout3',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/PyKLoA0B.webp',
    // These are the base configs mapped with each layout
    configs: {
      layout: {
        layoutName: 'layout3',
        layoutType: 'grid',
      },
      card: {
        contentConfig: {
          textConfig: {
            appearanceButton: [
              {
                type: 'textual',
                buttonAnimationConfig: { classKey: '', animationName: 'None' },
              },
            ],
          },
          buttonConfig: [{ isShow: true }],
        },
      },
    },
  },
  {
    name: 'layout4',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/sy3HSJmO.webp',
    // These are the base configs mapped with each layout
    configs: {
      layout: {
        layoutName: 'layout4',
        layoutType: 'carousel',
      },
      card: {
        contentConfig: {
          textConfig: {
            appearanceButton: [
              {
                type: 'textual',
                buttonAnimationConfig: { classKey: '', animationName: 'None' },
              },
            ],
          },
          buttonConfig: [{ isShow: true }],
        },
      },
    },
  },
];

// Constant and some other data

const POSITIONS_DATA = [
  {
    text: 'Left',
    value: 'left',
    iconBaseClass: 'wb-sprite ic-align-left faded',
    iconActiveClass: 'wb-sprite ic-align-left',
    itemLevelClass: 'tw-w-[50%]',
  },
  {
    text: 'Centre',
    value: 'center',
    iconBaseClass: 'wb-sprite ic-align-center faded',
    iconActiveClass: 'wb-sprite ic-align-center',
    itemLevelClass: 'tw-w-[50%]',
  },
];

const CARD_TEXT_ALIGNMENT = [
  {
    text: 'Left',
    value: 'left',
    iconBaseClass: 'wb-sprite ic-align-left faded',
    iconActiveClass: 'wb-sprite ic-align-left',
    itemLevelClass: 'tw-w-[33%]',
  },
  {
    text: 'Centre',
    value: 'center',
    iconBaseClass: 'wb-sprite ic-align-center faded',
    iconActiveClass: 'wb-sprite ic-align-center',
    itemLevelClass: 'tw-w-[33%]',
  },
  {
    text: 'Right',
    value: 'right',
    iconBaseClass: 'wb-sprite ic-align-right faded',
    iconActiveClass: 'wb-sprite ic-align-right',
    itemLevelClass: 'tw-w-[33%]',
  },
];

const getCardShare = (text, spiteDetails) => (
  <div className="tw-flex tw-items-center tw-gap-[10px]">
    <div className={`wb-sprite ${spiteDetails}`}></div>
    <div>{text}</div>
  </div>
);

export const CARD_SHAPE_DROPDOWN = [
  {
    value: 'square',
    renderData: () => getCardShare('Square (1:1)', 'ic-square'),
  },
  {
    value: 'portraitTall',
    renderData: () => getCardShare('Portrait tall (2:3)', 'ic-PortraitTall'),
  },
  {
    value: 'portraitShort',
    renderData: () => getCardShare('Portrait short (3:4)', 'ic-PortraitShort'),
  },
  {
    value: 'landscape',
    renderData: () => getCardShare('Landscape (3:2)', 'ic-landscape'),
  },
  {
    value: 'landscapeWide',
    renderData: () => getCardShare('Landscape (4:3)', 'ic-landscape2'),
  },
  {
    value: 'circle',
    renderData: () => getCardShare('Circle (1:1)', 'ic-circle'),
  },
  {
    value: 'blob',
    renderData: () => getCardShare('Blob (1:1)', 'ic-blob'),
  },
  {
    value: 'arch',
    renderData: () => getCardShare('Arch (3:4)', 'ic-arch'),
  },
];

export const ARROW_SHAPE_DROPDOWN = [
  {
    value: 'circular',
    renderData: () => getCardShare('Circular', 'ic-arrow-circle'),
  },
  {
    value: 'rounded',
    renderData: () => getCardShare('Rounded', 'ic-arrow-rounded'),
  },
  {
    value: 'square',
    renderData: () => getCardShare('Square', 'ic-arrow-square'),
  },
];

export const PROGRESS_INDICATOR_DROPDOWN = [
  {
    text: 'None',
    value: 'none',
  },
  {
    text: 'Short progress bar',
    value: 'shortProgressBar',
  },
  {
    text: 'Full width bar',
    value: 'fullWidthBar',
  },
  {
    text: 'Dash and dots',
    value: 'dashAndDots',
  },
];

export const TEXT_CASE = [
  {
    text: 'Default',
    value: 'none',
    itemLevelClass: 'tw-w-[33%]',
  },
  {
    text: 'Aa',
    value: 'capitalize',
    itemLevelClass: 'tw-w-[33%]',
  },
  {
    text: 'AA',
    value: 'uppercase',
    itemLevelClass: 'tw-w-[33%]',
  },
];

const TEXT_POSITION_DROPDOWN = [
  {
    text: 'On card - Top',
    value: 'top',
  },
  {
    text: 'On card - Middle',
    value: 'middle',
  },
  {
    text: 'On card - Bottom',
    value: 'bottom',
  },
  {
    text: 'Below',
    value: 'below',
  },
];

export const ARROW_POSITION = [
  {
    text: 'Top',
    value: 'top',
  },
  {
    text: 'Center',
    value: 'center',
  },
  {
    text: 'bottom',
    value: 'bottom',
  },
];

export const TEXT_SIZE_DROPDOWN = [
  {
    text: 'Extra small (12px)',
    value: 'extraSmall',
    itemLevelClass: { fontSize: '12px !important' },
  },
  {
    text: 'Small (14px)',
    value: 'small',
    itemLevelClass: { fontSize: '14px !important' },
  },
  {
    text: 'Medium (16px)',
    value: 'medium',
    itemLevelClass: { fontSize: '16px !important' },
  },
  {
    text: 'Large (18px)',
    value: 'large',
    itemLevelClass: { fontSize: '18px !important' },
  },
  {
    text: 'Extra Large (20px)',
    value: 'extraLarge',
    itemLevelClass: { fontSize: '20px !important' },
  },
];

export const TEXT_THICKNESS = [
  {
    text: 'Thin',
    value: 'thin',
    itemLevelClass: { fontWeight: '300 !important' },
  },
  {
    text: 'Regular',
    value: 'regular',
    itemLevelClass: { fontWeight: '400 !important' },
  },
  {
    text: 'Medium',
    value: 'medium',
    itemLevelClass: { fontWeight: '500 !important' },
  },
  {
    text: 'Semi-bold',
    value: 'semiBold',
    itemLevelClass: { fontWeight: '600 !important' },
  },
  {
    text: 'Bold',
    value: 'bold',
    itemLevelClass: { fontWeight: '700 !important' },
  },
];

const HOVER_EFFECT_DROPDOWN = [
  {
    text: 'Zoom in',
    value: 'zoomIn',
  },
  {
    text: 'Ambient',
    value: 'ambient',
  },
];

// Complete config
export const ListPresentationConfig = {
  childrenBehaviourConfig: {
    builder: [
      {
        forType: 'layout',
        element: 'checkbox',
        componentLabel: 'On click, Open collections in new tab',
        accessKey: ['openInNewTab'],
        isDynamicLabel: true,
        getDynamicLabel: (data) =>
          data?.contentItems?.type === 'category'
            ? `On click, Open category in new tab`
            : `On click, Open collections in new tab`,
      },
    ],
  },
  sectionContent: {
    sectionHeading: 'Section content',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'layout',
        componentLabel: 'Heading',
        element: 'inputEditor',
        accessKey: ['heading'],
        charCountKey: 'headingCharCount',
        placeholder: 'Enter title',
        maxLength: 100,
      },
      {
        forType: 'layout',
        componentLabel: 'Description',
        element: 'inputEditor',
        placeholder: 'Enter description',
        charCountKey: 'descriptionCharCount',
        accessKey: ['description'],
        textColor: '#808080',
        maxLength: 100,
      },
      {
        forType: 'layout',
        componentLabel: 'Section colour',
        editLabel: 'Edit colour',
        uniqueKey: 'selectionColors',
        element: 'colorsCombination',
        accessKey: ['colors'],
      },
    ],
  },
  layoutAndDesign: {
    sectionHeading: 'Layout & design',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'layout',
        element: 'layoutComponent',
        layoutData: LIST_LAYOUT_SELECTABLES,
        modalHeading: 'Instagram layout',
        componentLabel: 'Desktop Layout',
        // accessKey: ['id'],
        accessKey: ['layoutName'],
      },
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'Card shape',
        accessKey: ['cardShape'],
        dropdownData: CARD_SHAPE_DROPDOWN,
        customChildRender: true,
        placeholder: '',
      },
      {
        forType: 'layout',
        componentLabel: 'Content position',
        element: 'multiselect',
        accessKey: ['textAlign'],
        componentData: POSITIONS_DATA,
      },
      {
        forType: 'layout',
        componentLabel: 'Number of columns - Desktop',
        element: 'slider',
        accessKey: ['numColumnsDesktop'],
        min: 2,
        max: 8,
        suffix: '',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Number of columns - Mobile',
        element: 'slider',
        accessKey: ['numColumnsMobile'],
        min: 1,
        max: 2,
        suffix: '',
        step: 1,
      },
    ],
  },
  // carouselSettings: {
  //   sectionHeading: 'Carousel settings',
  //   description: '',
  //   tooltipContent: '',
  //   isVisible: (layout) =>
  //     layout.layoutName === 'layout2' || layout.layoutName === 'layout4',
  //   builder: [
  //     {
  //       forType: 'layout',
  //       element: 'dropdown',
  //       componentLabel: 'Progress indicator',
  //       accessKey: ['progressIndicator'],
  //       dropdownData: PROGRESS_INDICATOR_DROPDOWN,
  //       customChildRender: false,
  //       placeholder: '',
  //     },
  //     {
  //       forType: 'layout',
  //       element: 'dropdown',
  //       componentLabel: 'Arrow shape',
  //       accessKey: ['arrowShape'],
  //       dropdownData: ARROW_SHAPE_DROPDOWN,
  //       customChildRender: true,
  //       placeholder: '',
  //     },
  //     {
  //       forType: 'layout',
  //       element: 'colorDetails',
  //       componentLabel: 'Arrow colour',
  //       colorsData: [
  //         {
  //           text: 'arrowColor',
  //           displayVal: 'Arrow colour',
  //           accessKey: ['arrowColor'],
  //           shouldUpdateData: false,
  //           data: [],
  //         },
  //         {
  //           text: 'shapeColor',
  //           displayVal: 'Shape colour',
  //           accessKey: ['shapeColor'],
  //           shouldUpdateData: false,
  //           data: [],
  //         },
  //       ],
  //     },
  //     {
  //       forType: 'layout',
  //       element: 'colorDetails',
  //       componentLabel: 'Progress indicator color',
  //       colorsData: [
  //         {
  //           text: 'progressIndicatorColor',
  //           displayVal: 'Colour',
  //           accessKey: ['progressIndicatorColor'],
  //           shouldUpdateData: false,
  //           data: [],
  //         },
  //       ],
  //     },
  //     {
  //       forType: 'layout',
  //       element: 'multiselect',
  //       componentLabel: 'Arrow position',
  //       accessKey: ['arrowPosition'],
  //       dynamicData: true,
  //       getDynamicData: (layout, onChange, activeWidgetProps) => {
  //         if (layout?.textAlign === 'left') {
  //           return ARROW_POSITION;
  //         } else {
  //           if (layout?.textAlign === 'left') {
  //             layout.textAlign = 'center';
  //             onChange(activeWidgetProps);
  //           }
  //           if (layout?.textAlign === 'center' && layout?.arrowPosition === 'top') {
  //             layout.arrowPosition = 'center';
  //             onChange(activeWidgetProps);
  //           }
  //           return ARROW_POSITION?.slice(1, 3);
  //         }
  //       },
  //       componentData: ARROW_POSITION,
  //     },
  //     {
  //       forType: 'layout',
  //       element: 'checkbox',
  //       componentLabel: 'Show arrows in mobile',
  //       accessKey: ['showArrowInMobile'],
  //     },
  //   ],
  // },
  viewAllButton: {
    isVisible: ({ listPresentation }) =>
      listPresentation?.layoutName === 'layout1' ||
      listPresentation?.layoutName === 'layout3',
    builder: [
      {
        forType: 'layout',
        element: 'button',
        dynamicHeading: true,
        getDynamicButtonHeading: (activeWidgetProps) =>
          `See all ${activeWidgetProps?.listPresentation?.contentItems?.type === 'collection' ? 'collections' : 'categories'}`,
        subHeading:
          'This button will be visible when all collections are not in display at front.',
        showColorCombination: true,
        showDeleteIcon: false,
        showRedirectionField: false,
        accessKey: ['viewAllItemsButtonConfig'],
      },
    ],
  },
  collectionName: {
    sectionHeading: 'Collection name',
    isDynamicHeading: true,
    getDynamicHeading: (data) =>
      data?.contentItems?.type === 'category' ? 'Category name' : 'Collection name',
    description: '',
    tooltipContent: '',
    isShow: true,
    builder: [
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'Position',
        accessKey: ['contentConfig', 'textConfig', 'yAlignment'],
        dynamicData: true,
        dynamicDataList: (activeWidgetProps) => {
          const layout = activeWidgetProps?.listPresentation;

          if (layout.layoutName === 'layout3' || layout.layoutName === 'layout4') {
            return TEXT_POSITION_DROPDOWN?.slice(0, TEXT_POSITION_DROPDOWN?.length - 1);
          } else {
            return TEXT_POSITION_DROPDOWN;
          }
        },
        customChildRender: false,
        placeholder: '',
      },
      {
        forType: 'layoutItem',
        componentLabel: 'Text alignment',
        element: 'multiselect',
        accessKey: ['contentConfig', 'textConfig', 'xAlignment'],
        componentData: CARD_TEXT_ALIGNMENT,
      },
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'Text thickness',
        accessKey: ['contentConfig', 'textConfig', 'textThicness'],
        dropdownData: TEXT_THICKNESS,
        customChildRender: false,
        placeholder: '',
      },
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'Text size',
        accessKey: ['contentConfig', 'textConfig', 'textSize'],
        dropdownData: TEXT_SIZE_DROPDOWN,
        customChildRender: false,
        placeholder: '',
      },
      {
        forType: 'layoutItem',
        componentLabel: 'Text case',
        element: 'multiselect',
        accessKey: ['contentConfig', 'textConfig', 'textCase'],
        componentData: TEXT_CASE,
      },
      {
        forType: 'layoutItem',
        element: 'colorDetails',
        conditionalRender: true,
        isVisible: (activeWidgetProps) =>
          activeWidgetProps?.listPresentation?.layoutName === 'layout3' ||
          activeWidgetProps?.listPresentation?.layoutName === 'layout4',
        componentLabel: '',
        colorsData: [
          {
            text: 'textColor',
            displayVal: 'Name colour',
            accessKey: [
              'contentConfig',
              'textConfig',
              'appearanceButton',
              'btnStyleConfig',
              'textColor',
            ],
            shouldUpdateData: false,
            data: [],
          },
        ],
      },
      {
        forType: 'layoutItem',
        componentLabel: 'Improve text readability',
        componentSubLabel: 'Image overlay',
        element: 'slider',
        accessKey: ['contentConfig', 'textConfig', 'overlayOpacity'],
        min: 1,
        max: 100,
        suffix: '%',
        step: 1,
      },
    ],
  },
  collectionNameButton: {
    isDynamicHeading: true,
    getDynamicHeading: (data) =>
      data?.contentItems?.type === 'category' ? 'Category name' : 'Collection name',
    description: '',
    tooltipContent: '',
    isVisible: (activeWidgetProps) =>
      activeWidgetProps?.listPresentation?.layoutName === 'layout1' ||
      activeWidgetProps?.listPresentation?.layoutName === 'layout2',
    builder: [
      {
        forType: 'layoutItem',
        element: 'button',
        buttonHeading: 'Collection name appearance',
        dynamicHeading: true,
        getDynamicButtonHeading: (data) =>
          `${data?.contentItems?.type === 'collection' ? 'Collection' : 'Category'} name appearance`,
        showColorCombination: true,
        showDeleteIcon: false,
        showRedirectionField: false,
        showButtonNameField: false,
        showOnOffToggle: false,
        buttonStyleName: 'Appearance',
        hoverAnimationName: 'Name hover animation',
        buttonColorName: 'Name colour',
        accessKey: ['contentConfig', 'textConfig', 'appearanceButton'],
      },
    ],
  },
  collectionButton: {
    isVisible: (activeWidgetProps) =>
      activeWidgetProps?.listPresentation?.layoutName === 'layout3' ||
      activeWidgetProps?.listPresentation?.layoutName === 'layout4',
    builder: [
      {
        forType: 'layoutItem',
        element: 'button',
        showColorCombination: true,
        showDeleteIcon: false,
        showRedirectionField: false,
        showOnOffToggle: false,
        accessKey: ['contentConfig', 'buttonConfig'],
      },
    ],
  },
  hoverEffect: {
    sectionHeading: 'Hover effect',
    builder: [
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'Card hover effect',
        accessKey: ['hoverEffect'],
        dropdownData: HOVER_EFFECT_DROPDOWN,
        customChildRender: false,
        placeholder: '',
      },
    ],
  },
  sectionSetting: {
    sectionHeading: 'Section settings',
    builder: [
      {
        forType: 'layout',
        componentLabel: 'Desktop padding top and bottom',
        element: 'slider',
        accessKey: ['paddingY'],
        min: 0,
        max: 150,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Mobile padding top and bottom',
        element: 'slider',
        accessKey: ['mobilePaddingY'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Margin top',
        element: 'slider',
        accessKey: ['marginTop'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Margin bottom',
        element: 'slider',
        accessKey: ['marginBottom'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
    ],
  },
};

export const CONTENT_POSITION_TYPE = {
  OVERLAY: 'overlay',
  BELOW: 'below',
};

export const LIST_TYPE = {
  COLLECTIONS: 'collections',
  CATEGORY: 'category',
};

export const LIST_ITEM_HEADING = {
  PLP: 'Collection in preview',
  collection: 'Collections',
  category: 'Categories',
  featuredCollection: 'Collections',
  featuredTag: 'Tags',
  FeaturedCategory: 'Category',
};

export const CARD_SHAPE = 'cardShape';
export const Y_ALIGNMENT = 'yAlignment';
export const IMAGE_OVERLAY_TOP = ['top', 'middle', 'bottom'];

export const DEFAULT_COLLECTION_CARD_IMAGE =
  'https://cdn.dotpe.in/longtail/themes/8073865/JXSaayl0.webp';
